import { render } from "./CustomerPage.vue?vue&type=template&id=20d82175&ts=true"
import script from "./CustomerPage.vue?vue&type=script&lang=ts"
export * from "./CustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/QuanLy_Spa/QuanLy_Spa_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__